import TextInput from './TextInput.vue';

export default TextInput;
